import React from 'react';
import styled from 'styled-components';
import { ZoomControls } from '@clatter/ui';

const StyledControlsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .MuiSvgIcon-root {
    font-size: 14px !important;
    width: 14px !important;
    height: 14px !important;
  }
`;

interface GridZoomControlsProps {
  value: number;
  onChange: (value: number) => void;
  step?: number;
  min?: number;
  max?: number;
}

export const getColumnsFromZoom = (zoomValue: number): number => {
  if (zoomValue >= 100) return 1;
  if (zoomValue >= 80) return 2;
  if (zoomValue >= 60) return 3;
  if (zoomValue >= 40) return 4;
  if (zoomValue >= 20) return 5;
  return 6;
};

const GridZoomControls = ({ value, onChange, step = 20, min = 0, max = 100 }: GridZoomControlsProps) => {
  return (
    <StyledControlsContainer>
      <ZoomControls value={value} onChange={onChange} step={step} min={min} max={max} />
    </StyledControlsContainer>
  );
};

export default GridZoomControls;
